import { render, staticRenderFns } from "./myHeader.vue?vue&type=template&id=b8f9003c&scoped=true"
import script from "./myHeader.vue?vue&type=script&lang=js"
export * from "./myHeader.vue?vue&type=script&lang=js"
import style0 from "./myHeader.vue?vue&type=style&index=0&id=b8f9003c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f9003c",
  null
  
)

export default component.exports